"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mergeClassName(...items) {
    const ans = [];
    for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (!item)
            continue;
        if (Array.isArray(item) && item.length > 0) {
            ans.push(...item.filter(x => !!x).map(x => String(x)));
        }
        if (typeof item === "string") {
            ans.push(item);
        }
    }
    return ans.length ? ans.join(' ') : undefined;
}
exports.default = mergeClassName;
//# sourceMappingURL=mergeClassName.js.map